// extracted by css-extract-rspack-plugin
export default {"EligibleOfferTileLearnMoreLink":"sputnik__EligibleOfferTileLearnMoreLink__WRsr3","eligibleOfferTileLearnMoreLink":"sputnik__EligibleOfferTileLearnMoreLink__WRsr3"};